import { mapGetters } from 'vuex'
import captcha from '../../../api/captcha'
import user from '../../../api/user'
export default {
  data() {
    return {
      form: {},
      code: {},
      rules: {}
    }
  },
  computed: {
    ...mapGetters({
      user: 'getUser',
      language: 'getLanguage',
      publisherInfo: 'getPublisherInfo',
      publisherId: 'getPublisherId'
    })
  },
  mounted() {
    this.getCaptcha()
    this.getRules()
    document.onkeyup = e => {
      // 兼容FF和IE和Opera
      var event = e || window.event
      var key = event.which || event.keyCode || event.charCode
      if (key == 13 && this.$route.path === '/access/login') {
        this.submit()
      }
    }
  },
  methods: {
    async submit() {
      const flag = this.$refs['forget-form'].validate()
      if (flag) {
        const data = Object.assign(
          { publisherId: this.publisherId, cid: this.code.cid },
          this.form
        )
        try {
          await user.forget(data)
          this.$router.push(
            `/access/result?email=${this.form.email}&type=forget`
          )
        } catch (e) {
          this.getCaptcha()
          return
        }
      }
    },
    async getCaptcha() {
      this.code = await captcha.get()
    },
    getRules() {
      this.rules = {
        email: [
          {
            required: true,
            message: 'Email' + this.LANGUAGE[this.language].noEmpty + '.'
          },
          {
            type: 'email',
            message: this.LANGUAGE[this.language].inputCorrectEmail + '.'
          }
        ],
        code: [
          {
            required: true,
            message:
              'Verification Code' + this.LANGUAGE[this.language].noEmpty + '.'
          }
        ]
      }
    }
  }
}
